module.exports = __webpack_public_path__ + "static/media/l_itdot_9.e58adf8b.png";